import Vue from 'vue'
import configs from '@/config'
import textUtil from '@/utils/textUtil'

let resource = null

const actions = {
  getGlobalInvitationNotifications: {
    method: 'GET',
    url: `${configs.baseUrl}/api/invitations?status={status}&email={invitedEmail}`,
  },
  getInvitations: {
    method: 'GET',
    url: `${configs.baseUrl}/api/invitations`,
  },
  createInvitations: {
    method: 'POST',
    url: `${configs.baseUrl}/api/invitations`,
  },
  patchInvitation: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/invitations/{invitationId}`,
  },
  acceptInvitation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/invitations/{invitationId}/accept`,
  },
  declineInvitation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/invitations/{invitationId}/decline`,
  },
  viewInvitation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/invitations/view`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const sanitizeInvitationField = (res) => {
  res.body.invitations.forEach((invitation) => {
    invitation.account.name = textUtil.sanitize(invitation.account.name)
  })
}

const getGlobalInvitationNotifications = async ({ status, invitedEmail }) => {
  const res = await resource.getGlobalInvitationNotifications({ status, invitedEmail })
  sanitizeInvitationField(res)
  return res.body.invitations
}

const getInvitations = async () => {
  const res = await resource.getInvitations()
  sanitizeInvitationField(res)
  return res.body.invitations
}

const createInvitations = async (params) => {
  const res = await resource.createInvitations(params)
  return res.body.invitations
}

const patchInvitation = async (invitationId, params) => {
  const res = await resource.patchInvitation({ invitationId }, params)
  return res.body.invitation
}

const acceptInvitation = async (invitationId) => {
  const res = await resource.acceptInvitation({ invitationId }, null)
  return res.body
}

const declineInvitation = async (invitationId) => {
  const res = await resource.declineInvitation({ invitationId }, null)
  return res.body
}

const viewInvitation = async () => {
  const res = await resource.viewInvitation()
  return res.body
}

export default {
  initResource,
  getGlobalInvitationNotifications,
  getInvitations,
  createInvitations,
  patchInvitation,
  acceptInvitation,
  declineInvitation,
  viewInvitation,
}
